// extracted by mini-css-extract-plugin
export var accordionChevron = "SlideInMenuSubMenu-module--accordionChevron--38a60";
export var dropdownCategory = "SlideInMenuSubMenu-module--dropdownCategory--ad80f";
export var dropdownCategoryItem = "SlideInMenuSubMenu-module--dropdownCategoryItem--442f0";
export var dropdownCategoryTitle = "SlideInMenuSubMenu-module--dropdownCategoryTitle--a1016";
export var dropdownContainer = "SlideInMenuSubMenu-module--dropdownContainer--2bb33";
export var dropdownContainerOpen = "SlideInMenuSubMenu-module--dropdownContainerOpen--89794";
export var dropdownToggle = "SlideInMenuSubMenu-module--dropdownToggle--9853d";
export var item = "SlideInMenuSubMenu-module--item--4fcce";
export var link = "SlideInMenuSubMenu-module--link--913cf";
export var subMenuContainer = "SlideInMenuSubMenu-module--subMenuContainer--066ca";